import { useEffect, useState } from "react"
import { Spinner } from "react-bootstrap"

const RenderButtonForCalendar = (props) => {
    const {
        isActive,
        onClick,
        eventData,
        title,
        isLoaded,
        isLiveButton,
        tooltip
    } = props

    const [isLoading, setIsLoading] = useState(false)

    useEffect(() => {
        if (!isLoaded && isLoading) {
            setIsLoading(false)
        }
    }, [isLoaded])

    const handleClick = () => {
        if(eventData?.cancel_request && title==="Cancel"){
            return;
        }
        if (!isLoading && isActive) {
            setIsLoading(true)
            onClick(eventData)
        }
    }


    return (
        <button
            id={isLiveButton===true?"liveButton":"popcal-" + eventData.sessionId + eventData.segmentId}
            className={`btn-join ${ isActive ? 'active' : 'cursor-default'}
            ${title === 'View' ? 'view-btn' : ''} ${eventData?.cancel_request && title==="Cancel"? 'disable-button' : ''}`}
            onClick={handleClick}
            title={eventData?.cancel_request && title==="Cancel"?"Your session cancellation request is still pending.":""}>
            {isLoading ?
                <Spinner
                    as="span"
                    animation="border"
                    size="sm"
                    role="status"
                    aria-hidden="true"
                    variant="primary"
                />
                : title}
        </button>
    )
}

export default RenderButtonForCalendar